import React from 'react'
import { RiAddCircleLine } from "react-icons/ri"
import { Link, useParams } from 'react-router-dom';
import Nav from '../Nav/Nav';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../api/api';
import { toast } from "react-toastify"

const GETDATABYID = "api/audio"
const EDITDATA = 'api/audio/update'
function EditAudio() {

    const { id } = useParams()
    const [editabledata, Setalleditabledata] = useState([]);
    const [loading, Setloading] = useState(false)

    const navigate = useNavigate();
    document.title = "Edit Audio-Jain Sadhana "

    useEffect(() => {
        const getdatabyid = async () => {
            try {
                const response = await axios.get(`${GETDATABYID}/${id}`)
                const data = response?.data?.audio
                Setalleditabledata(data)

            } catch (error) {
                console.log(error?.response?.data?.message)
            }
        }
        getdatabyid();
    }, [id])


    const HandleEdit = async (event) => {
        Setloading(true)
        event.preventDefault();

        const data = new FormData();

        data.append('audiotitle', editabledata.audiotitle);
        data.append('audiotype', editabledata.audiotype);
        data.append('audiofile', editabledata.audiofile);


        try {
            const response = await axios.patch(`${EDITDATA}/${id}`, data)
            if (response.status === 200) {
                navigate('/menu/audiolist')
                Setloading(false)
                toast.success('Successfully Edited')


            }

        } catch (error) {
            console.log(error.response.data.message)
            setTimeout(()=>Setloading(false),1000)
        }
    }





    return (
        <div className="container-fluid mt-3">
            <div className="row me-auto w-100">
                <div className="col-lg-3 px-4">
                    <Nav TaskTitleClass="active" audio="text-white" />
                </div>
                <div className="col-lg-9">
                    <div className='font '>

                        {/* section 2 */}
                        <div className='container-fluid content-list-main-box mb-5' >
                            <div className=' position-relative content-box' >
                                <div className='d-flex mb-3 justify-content-between align-item-center' >
                                    <p className='list-page-title text-black'  >Edit Audio</p>
                                    <Link to="/menu/audiolist" className='text-black btn button-yellow  back-list-button'>
                                        <i className='me-2' ><RiAddCircleLine /></i> List All Audio</Link>
                                </div>
                                <div>
                                    <form onSubmit={HandleEdit}>
                                        <div className="row employ-form-list">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <label htmlFor="audiotitle" className='label-style'>Audio Title</label>
                                                            <input type="text" value={editabledata.audiotitle} onChange={(event) => Setalleditabledata({ ...editabledata, audiotitle: event.target.value })} className="form-control  bg-gray border border-0" id="audiotitle" name='audiotitle' placeholder="Audio Title" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">

                                                        <div className="mb-3">
                                                            <label htmlFor="audiotype" className='label-style'>Audio Category</label>

                                                            <select value={editabledata.audiotype} onChange={(event) => Setalleditabledata({ ...editabledata, audiotype: event.target.value })} className="form-control  bg-gray border border-0" id="audiotype" name='audiotype' placeholder="Type Of Audio" required>
                                                                <option value="">select category</option>
                                                                <option value="tatvarthasutra">Tatvartha Sutra</option>
                                                                <option value="paath">Paath</option>
                                                                <option value="samaysaar">Samay Saar</option>
                                                                <option value="strotra">Strotra</option>
                                                                <option value="bhajan">Bhajan</option>
                                                                <option value="chahdhala">Chah Dhala</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className=" mb-3">
                                                            <label htmlFor="upload-file" className='label-style'>Upload File(Required) </label>
                                                            <input name="audiofile" onChange={(event) => Setalleditabledata({ ...editabledata, audiofile: event.target.files[0] })} type="file" className="form-control " id="upload-file" 
                                                            />
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='d-flex  justify-content-center align-item-center mt-3' >
                                            {
                                                loading === true ? <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Loading... </button> : <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Submit</button>
                                            }
                                            <Link to={'/menu/audiolist'} className='btn  bg-black font-size text-white  mx-3 px-4 py-2 ' ><i className="fa-solid fa-xmark  mx-2"></i>Cancel</Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default EditAudio